export interface TopLevelFilterCache {
  productTypeId: string;
  category: { id: string; name: string } | null;
}

const keyFor = (view: 'pricing' | 'availability') => `outer-selection:${view}`;

export function loadOuterSelection(
  view: 'pricing' | 'availability',
): TopLevelFilterCache | null {
  try {
    const saved = JSON.parse(sessionStorage.getItem(keyFor(view)) ?? 'null');
    return saved?.productTypeId ? (saved as TopLevelFilterCache) : null;
  } catch {
    return null;
  }
}

export function saveOuterSelection(
  view: 'pricing' | 'availability',
  selection: TopLevelFilterCache,
): void {
  try {
    sessionStorage.setItem(keyFor(view), JSON.stringify(selection));
  } catch {
  }
}
